import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { tesaDark, tesaGrey1 } from "../../../../../../styles/colors";

const useStyles = makeStyles({
  listAddButton: {
    padding: 0,
    paddingTop: 10,
    paddingBottom: 10,
  },
  listAddButtonLabel: {
    paddingTop: 2,
    marginRight: -4,
    color: tesaDark,
  },
});

export default function HeadlineAddButton(props: {
  enabled: boolean;
  title: string;
  onClick: () => void;
}): JSX.Element {
  const classes = useStyles();
  const { enabled, title, onClick } = props;
  return (
    <Button
      disabled={!enabled}
      className={classes.listAddButton}
      onClick={onClick}
      endIcon={enabled ? <AddIcon fontSize="small" htmlColor={tesaGrey1} /> : undefined}
    >
      <span className={classes.listAddButtonLabel}>{title}</span>
    </Button>
  );
}
